"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Card_1 = require("../Card");
var core_1 = require("@blueprintjs/core");
var Form_1 = require("../Form");
var styles_1 = require("./styles");
var PreviewComponent_1 = __importDefault(require("./PreviewComponent"));
var getFileNameAndExt = function (completeFileName) {
    var splicedFileName = completeFileName.split('.');
    if (splicedFileName.length > 1) {
        var fileExt = splicedFileName[splicedFileName.length - 1];
        var fileName_1 = '';
        splicedFileName.some(function (item, index) {
            fileName_1 += "".concat(item).concat(index !== splicedFileName.length - 2 ? '.' : '');
            return index === splicedFileName.length - 2;
        });
        return { fileName: fileName_1, fileExt: fileExt };
    }
    return {
        fileName: '',
        fileExt: ''
    };
};
var ConfirmAndEditFile = function (props) {
    var handleFinish = props.handleFinish, toggleIsOpen = props.toggleIsOpen, eraseFile = props.eraseFile, triggerFileBrowser = props.triggerFileBrowser, isOpen = props.isOpen, changeFileName = props.changeFileName, file = props.file;
    var _a = (0, react_1.useState)(''), url = _a[0], setUrl = _a[1];
    var _b = (0, react_1.useState)(''), type = _b[0], setType = _b[1];
    var _c = (0, react_1.useState)(''), fileExt = _c[0], setFileExt = _c[1];
    var _d = (0, react_1.useState)(''), fileName = _d[0], setFileName = _d[1];
    (0, react_1.useEffect)(function () {
        if (file) {
            setUrl(window.URL.createObjectURL(file));
            setType(file.type);
            var _a = getFileNameAndExt(props.fileName), fileExt_1 = _a.fileExt, fileName_2 = _a.fileName;
            setFileName(fileName_2);
            setFileExt(fileExt_1);
        }
        else {
            clear();
        }
    }, [file, props.fileName]);
    var clear = function () {
        setFileExt('');
        setFileName('');
        setUrl('');
        setType('');
    };
    var handleChangeFileName = function (value) {
        changeFileName("".concat(value, ".").concat(fileExt));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.StyledDialog, { isOpen: isOpen, isCloseButtonShown: false },
            react_1.default.createElement(Card_1.VCardPanel, { width: '340px', bodyPadding: '10px', headerText: 'Confirm or Edit File' },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.DivContainerTop, null,
                        react_1.default.createElement(styles_1.FileNameContainer, null,
                            react_1.default.createElement(Form_1.VInputField, { id: 'fileName', fill: true, noLabel: true, value: fileName, onChange: handleChangeFileName, rightElement: react_1.default.createElement(core_1.AnchorButton, { onClick: triggerFileBrowser, icon: 'cloud-upload' }) }),
                            react_1.default.createElement(styles_1.FileExtSpan, null, "".concat(fileExt && '.').concat(fileExt))),
                        react_1.default.createElement(styles_1.PreviewContainer, null,
                            react_1.default.createElement(PreviewComponent_1.default, { url: url, type: type }))),
                    react_1.default.createElement(core_1.Divider, null),
                    react_1.default.createElement(styles_1.ButtonsRowContainer, null,
                        react_1.default.createElement(core_1.Button, { minimal: true, intent: 'success', icon: 'tick', onClick: handleFinish, text: 'Finish' }),
                        react_1.default.createElement(core_1.Button, { minimal: true, intent: 'warning', icon: 'eraser', onClick: eraseFile, text: 'Clear' }),
                        react_1.default.createElement(core_1.Button, { minimal: true, intent: 'danger', icon: 'cross', onClick: toggleIsOpen, text: 'Cancel' })))))));
};
exports.default = ConfirmAndEditFile;
